import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { FadeUp } from "@/components/site/Reveal";
import { Marquee } from "@/components/site/Marquee";
import { IMG, SERVICES } from "@/data/content";

const Row = ({ s, i }) => (
  <article id={s.slug} data-testid={`service-detail-${s.slug}`} className="scroll-mt-24 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center py-16 md:py-24 border-b border-slate-200 last:border-0">
    <FadeUp className={`lg:col-span-6 ${i % 2 ? "lg:order-2" : ""}`}>
      <motion.div initial={{ clipPath: "inset(12% 12% 12% 12% round 24px)" }} whileInView={{ clipPath: "inset(0% 0% 0% 0% round 24px)" }}
        viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }} className="aspect-[5/4] overflow-hidden">
        <img src={IMG[s.img]} alt={s.title} className="h-full w-full object-cover" />
      </motion.div>
    </FadeUp>
    <FadeUp delay={0.1} className="lg:col-span-6">
      <span className="font-mono-x text-sky-700">{s.no} / 0{SERVICES.length}</span>
      <h2 className="mt-4 text-4xl md:text-5xl font-extrabold tracking-[-0.04em] text-[#0A192F]">{s.title}</h2>
      <p className="mt-6 text-slate-600 text-base md:text-lg leading-relaxed max-w-lg">{s.long}</p>
      <ul className="mt-8 space-y-3">
        {s.points.map((p) => (
          <li key={p} className="flex items-center gap-3 text-[#0A192F] font-medium"><span className="w-6 h-6 rounded-full bg-sky-100 grid place-items-center"><Check size={14} className="text-sky-700" /></span>{p}</li>
        ))}
      </ul>
      <Link to="/contact#enquiry" data-testid={`btn-enquire-${s.slug}`} className="mt-10 inline-flex items-center gap-2 font-semibold text-[#0A192F] border-b-2 border-sky-500 pb-1 hover:text-sky-700 transition-colors">Enquire about {s.title.toLowerCase()} <ArrowUpRight size={16} /></Link>
    </FadeUp>
  </article>
);

export default function Services() {
  return (
    <div data-testid="page-view-services">
      <PageHero testId="services-hero" eyebrow="Services" lines={["Clinical cover.", <>Care at <span className="font-serif-i font-normal tracking-normal text-sky-300">home.</span></>]}
        intro="Two services, one standard. Every placement is matched by a clinician and supported by a local coordinator, 24 hours a day." />
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">{SERVICES.map((s, i) => <Row key={s.slug} s={s} i={i} />)}</div>
      </section>
      <Marquee />
    </div>
  );
}
